export default class DefaultRule {
    isSupport(filters, node) {
        return true;
    }
    getColor() {
        return '#c4c4c4';
    }
    getTextColor() {
        return '#2D2D2D';
    }
    getNodeBackgroundColor() {
        return '#c4c4c4';
    }
    getOpacity() {
        return 1
    }
}
